module.exports = __webpack_public_path__ + "img/vegetarian.5eb351af.svg";